import React from "react";
import { toast } from "react-toastify";
import { Input, Select, Textarea } from "../../../components/form";
import { Button } from "../../../components/button";
import { useCreateArticle } from "../hooks";
import { CustomerSelectSearch } from "../../customers/components";
import { ArticleType } from "../../../__generated__/globalTypes";
import { articleTypeLabel } from "../../../helpers/enum-labels";

interface IProps {
  customerId?: number;
  onCompleted: () => void;
}

export const ArticleForm: React.FC<IProps> = ({ customerId, onCompleted }) => {
  const { form, submit, loading } = useCreateArticle({
    defaultValues: { customerId, type: ArticleType.Long },
    onCompleted: () => {
      toast.success("L'article a été enregistré avec succès");
      form.reset({ customerId, type: ArticleType.Long });
      onCompleted();
    },
  });

  return (
    <div className="flex flex-wrap gap-3 items-end">
      {!customerId && (
        <CustomerSelectSearch form={form} name="customerId" label="Client" />
      )}
      <Input
        label="Site"
        className="w-full"
        {...form.register("site", { required: "Site requis" })}
        placeholder="https://client.fr"
      />
      <Select label="Type" className="w-full" {...form.register("type", { required: true })}>
        {Object.keys(ArticleType).map((key) => (
          <option key={key} value={key}>
            {articleTypeLabel(key)}
          </option>
        ))}
      </Select>
      <Input
        label="Titre"
        className="w-full"
        {...form.register("title", { required: "Titre requis" })}
      />
      <Textarea
        label="Contenu"
        className="w-full"
        {...form.register("content", { required: "Contenu requis" })}
        placeholder="Contenu de l'article..."
      />
      <Button onClick={submit} loading={loading} disabled={loading}>
        Enregistrer l'article
      </Button>
    </div>
  );
};
